var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BaseInputText',{attrs:{"placeholder":"Contraseña","style-modifier":"white","required":true,"error-message":"Contraseña incorrecta","min-length":8,"type":_vm.inputType,"autofocus":_vm.autofocus,"value":_vm.value,"is-error-message-visible":_vm.isInvalidPasswordMessageVisible},on:{"input":_vm.emitInputEvent}})
}
var staticRenderFns = []

export { render, staticRenderFns }